/* eslint-disable react/no-unused-prop-types */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';

export function NoElementsWarning({ selectElementsByParentId, parentId }) {
  const selectedElements = selectElementsByParentId(parentId, {
    omitHidden: true,
  });

  return selectedElements.length ? null : (
    <div className="no-elements-on-redirect-page">
      Please add the fallback page content in case of failure to auto-redirect.
    </div>
  );
}

NoElementsWarning.propTypes = {
  parentId: PropTypes.string.isRequired,
  selectElementsByParentId: PropTypes.func.isRequired,
};

NoElementsWarning.defaultProps = {};
